import { Router } from '@angular/router';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormsModule, NgForm } from '@angular/forms';
import { LoginModel } from '../_interfaces/login.model';
import { InactivityService } from '../shared/services/InactivityService';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.html',
  styleUrl: './login.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule],
})
export class Login {
  invalidLogin: boolean = false;
  credentials: LoginModel = { email: '', password: '' };
  constructor(
    private router: Router,
    private authService: AuthService,
    private inactivityService: InactivityService,
  ) {}
  ngOnInit(): void {}
  login = (form: NgForm) => {
    if (form.valid) {
      this.authService.login(this.credentials.email, this.credentials.password).subscribe({
        next: () => {
          this.invalidLogin = false;
          this.inactivityService.startTracking();
          this.router.navigate(['/']);
        },
        error: (err: HttpErrorResponse) => (this.invalidLogin = true),
      });
    }
  };
}
